export type TMChangeOrderTypeId = string;

export enum TMChangeOrderTypeCode {
  customer = 'customer',
  subcontractor = 'subcontractor',
  administrative = 'administrative',
  internal = 'internal',
}

/**
 * A change order type (Settings > Time & Materials > Change Order Types). Its settings decide the change order's
 * workflow. Every type can go on an invoice except the ones that must net to $0.
 */
export interface TMChangeOrderTypeResponse {
  id: TMChangeOrderTypeId;
  name: string;
  // The 4 built-in types can be renamed and changed, but not deleted
  code: TMChangeOrderTypeCode | null;
  isBuiltIn: boolean;
  needsInternalApproval: boolean;
  needsClientApproval: boolean;
  subcontractorsCanSubmit: boolean;
  mustNetZero: boolean;
  // What the logged-in user can do with this type
  can: { create: boolean; approve: boolean };
}

export interface TMChangeOrderTypeRequest {
  name: string;
  needsInternalApproval: boolean;
  needsClientApproval: boolean;
  subcontractorsCanSubmit: boolean;
  mustNetZero: boolean;
}

// What the logged-in user can do with a change order, sent by the API (TMChangeOrder::actionsFor)
export interface TMChangeOrderActions {
  edit: boolean;
  // Add, remove or fully change lines (a Draft); otherwise an edit only changes quantities and prices
  changeLines: boolean;
  delete: boolean;
  approve: boolean;
  reject: boolean;
  send: boolean;
  invoice: boolean;
}

// The button clicked in the change order form; the server picks the status from it and the type
export enum TMChangeOrderSaveAction {
  draft = 'draft',
  save = 'save',
  approve = 'approve',
  send = 'send',
}
